import { render, staticRenderFns } from "./DisabilityInfo.vue?vue&type=template&id=abacc510&scoped=true"
import script from "./DisabilityInfo.vue?vue&type=script&lang=js"
export * from "./DisabilityInfo.vue?vue&type=script&lang=js"
import style0 from "./DisabilityInfo.vue?vue&type=style&index=0&id=abacc510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abacc510",
  null
  
)

export default component.exports